import { ITranslationEntry } from '../lang';

export const MS: ITranslationEntry = {
  translations: {
    notifications: 'Pemberitahuan',
    markAllAsRead: 'Tandakan semua sebagai telah dibaca',
    poweredBy: 'Dikuasai oleh',
    settings: 'Tetapan',
  },
  lang: 'ms',
};
